<div [class.cm-square-container]="$squareFormat()" [class.cm-default-container]="!$squareFormat()">
    <div class="cm-file-add">
        <i class="far fa-plus"></i>
        <input class="cm-select-file" (change)="selectFiles($event)" type="file" multiple />
    </div>
</div>
